import React from "react";
import { style, classes } from "typestyle";
import { Black, GrayLight } from "@traceair/tds";

type RollbackButtonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const RollbackButton = ({ onClick }: RollbackButtonProps) => {
  return (
    <button
      onClick={onClick}
      className={classes(
        style({
          cursor: "pointer",
          position: "absolute",
          right: "0",
          margin: "0px 24px 0px 0px",
          lineHeight: "24px",
          border: 0,
          height: "24px",
          padding: "5px 6px 5px 8px",
          borderRadius: "8px",
          background: GrayLight,
          color: Black,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }),
      )}
    >
      <img
        className={classes(
          style({
            paddingRight: "6px",
          }),
        )}
        src={"icon-rollback.svg"}
      />
      <span
        className={classes(
          style({
            fontSize: "12px",
            fontFamily: "Roboto",
            fontStyle: "normal",
            fontWeight: "normal",
            letterSpacing: "-0.25px",
            whiteSpace: "nowrap",
          }),
        )}
      >
        {"Rollback"}
      </span>
    </button>
  );
};

export default RollbackButton;
